import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getToken, setToken } from "../utils/Api";
import { validateUserToken } from "../utils/ApiCalls/UserCalls";
import { useDataLayerValue } from "./DataLayer";

const ProtectedRoute = ({ children }) => {
  const [{ token }, dispatch] = useDataLayerValue();


  const navigate = useNavigate();
  const validateUser = async () => {
    let data = await validateUserToken();
    if (data.message) {
      navigate("/login");
    } else {
      getToken();
      dispatch({
        type: "SET_USER_DETAILS",
        userDetails: data,
      });
    }
  };
  useEffect(() => {
    let token = localStorage.getItem("token");
    if (token) {
      validateUser();

      setToken(token);
    } else {

      navigate("/login");
    }
  }, [token]);

  return children;
};

export default ProtectedRoute;
